export const ACCESS_TOKEN_STORAGE = 'access_token';
export const USER_STORAGE = 'user_storage';
export const CLEAR_STORE = 'CLEAR_STORE';
